import React from 'react';

const SvgFm = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="FM_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="FM_svg__b" fill="#fff">
        <use xlinkHref="#FM_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#FM_svg__a" />
      <path fill="#95CEF5" mask="url(#FM_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M14 5.76l-1.567 1.064.527-1.82-1.496-1.161 1.893-.06L14 2l.643 1.782 1.893.06-1.496 1.163.527 1.819L14 5.76zm0 10.667l-1.567 1.064.527-1.82-1.496-1.162 1.893-.06.643-1.782.643 1.782 1.893.06-1.496 1.162.527 1.82L14 16.427zm5.333-5.334l-1.567 1.064.528-1.82-1.497-1.161 1.894-.06.642-1.783.643 1.782 1.893.061-1.496 1.162.528 1.82-1.568-1.065zm-10.666 0l-1.568 1.064.528-1.82L6.13 9.177l1.893-.06.643-1.783.642 1.782 1.894.061-1.497 1.162.528 1.82-1.567-1.065z"
        fill="#FFF"
        mask="url(#FM_svg__b)"
      />
    </g>
  </svg>
);

export default SvgFm;
